module.exports = __webpack_public_path__ + "img/my-teams-pro.2bb6a7ee.svg";